export const OCCUPANCY_GUESTS = {
  s: 1,
  d: 2,
  t: 3,
  q: 4,
  p: 5,
  h: 6,
  hp: 7,
  o: 8,
  n: 9,
  de: 10,
  el: 11,
  tw: 12,
  th: 13,
  fo: 14,
};

export function isMappedChannelCode(roomCode, rateCode) {
  const room = String(roomCode || '').trim();
  const rate = String(rateCode || '').trim();
  if (!room || !rate || room !== room.toLowerCase() || rate !== rate.toLowerCase()) return false;
  if (rate === room || rate.startsWith(`${room}-`)) return true;
  return rate.includes('-');
}

function isTruthyFlag(value, fallback = true) {
  if (value === false || value === 0 || value === 'false') return false;
  if (value === true || value === 1 || value === 'true') return true;
  return fallback;
}

function isRatePlanChannelManager(mapping) {
  return isTruthyFlag(
    mapping?.rate_plan_is_channel_manager_enabled
    ?? mapping?.is_channel_manager_enabled
    ?? mapping?.rate_plan_cm,
    true
  );
}

function isRatePlanActive(mapping) {
  return isTruthyFlag(
    mapping?.rate_plan_is_active
    ?? mapping?.rate_plan_active
    ?? mapping?.plan_is_active,
    true
  );
}

/** Unique mapped room + CM rate-plan pairs from ChannelMapping rows. */
export function mappedChannelPairs(mappings) {
  const pairs = [];
  const seen = new Set();
  (Array.isArray(mappings) ? mappings : []).forEach((mapping) => {
    const roomId = mapping?.room_type_id;
    const planId = mapping?.rate_plan_id;
    if (!roomId || !planId) return;
    if (mapping?.is_active === false) return;
    if (!isRatePlanChannelManager(mapping)) return;
    if (!isRatePlanActive(mapping)) return;
    if (!isMappedChannelCode(mapping.channel_room_code, mapping.channel_rate_code)) return;
    const key = `${roomId}:${planId}`;
    if (seen.has(key)) return;
    seen.add(key);
    pairs.push({
      key,
      roomTypeId: roomId,
      roomTypeName: mapping.room_type_name || `Room ${roomId}`,
      ratePlanId: planId,
      ratePlanName: mapping.rate_plan_name || `Plan ${planId}`,
      ratePlanCode: mapping.rate_plan_code || mapping.channel_rate_code || '',
      channelRoomCode: mapping.channel_room_code || '',
      channelRateCode: mapping.channel_rate_code || '',
      mealPlan: mapping.rate_plan_meal_plan || mapping.meal_plan || '',
      sort_order: mapping.sort_order ?? 0,
      isChannelManagerEnabled: true,
      isPmsEnabled: false,
    });
  });
  return pairs;
}
